import APIRequestState from '../_util/api-request';

export default class UserPartnerAccountsState extends APIRequestState {
  get method() { return 'GET'; }
  get url() { return '/me/partner-accounts'; }
}



// WEBPACK FOOTER //
// ./spa/state/user/user-partner-accounts.jsx